import { render, staticRenderFns } from "./OrticValueSelectControl.vue?vue&type=template&id=4b400352"
import script from "./OrticValueSelectControl.vue?vue&type=script&lang=js"
export * from "./OrticValueSelectControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports